import { useEffect, useRef, useState } from 'react';
import { CheckIcon, CopyIcon, TicketIcon } from '@phosphor-icons/react';
import { copyText } from './clipboard.js';
import { t } from './i18n.js';

// Duração do recibo visual do "copiei" no localizador.
const COPIED_MS = 1500;

const CODE_KIND = {
  /** O código do voucher — a identidade Voll do serviço. */
  voucher: { ariaKey: 'trips.panel.copyVoucher', labelKey: null },
  /** Os códigos de terceiro precisam se apresentar: o número sozinho não diz de
   *  quem é, nem se é da companhia ou do hotel. */
  locator: { ariaKey: 'trips.panel.copyLocator', labelKey: 'trips.services.locatorShort' },
  /** O endereço do hotel na página da viagem (#6313): sublinhado, sem rótulo. */
  address: { ariaKey: 'trips.panel.copyAddress', labelKey: null },
  reservation: { ariaKey: 'trips.panel.copyReservation', labelKey: 'trips.services.reservation' },
} as const satisfies Record<string, { ariaKey: string; labelKey: string | null }>;

/** Um código copiável do passo. É o dado que a pessoa leva ao balcão — então é
 *  ação, não decoração. O check é o recibo do clique. */
export function CodeButton({
  kind,
  code,
}: Readonly<{ kind: keyof typeof CODE_KIND; code: string }>) {
  const meta = CODE_KIND[kind];
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
  useEffect(
    () => () => {
      clearTimeout(timer.current);
    },
    [],
  );
  return (
    <button
      type="button"
      className={`tp-code tp-code--${kind}`}
      aria-label={t(meta.ariaKey, { code })}
      onClick={() => {
        void copyText(code);
        setCopied(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => {
          setCopied(false);
        }, COPIED_MS);
      }}
    >
      {kind === 'voucher' && <TicketIcon size={11} aria-hidden />}
      {meta.labelKey && <span className="tp-code__k">{t(meta.labelKey)}</span>}
      {code}
      {copied ? (
        <CheckIcon size={12} weight="bold" aria-hidden />
      ) : (
        <CopyIcon size={12} aria-hidden />
      )}
    </button>
  );
}
